import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkmark, Label, Skeleton } from './components';
import './Checkbox.scss';
/**
 * Simple checkbox component that receives the default HTML input attributes and a label.
 */
export const Checkbox = ({ label, testId, loading, ...props }) => {
    if (loading)
        return _jsx(Skeleton, { hasLabel: !!label });
    return (_jsxs("label", { "data-testid": 'checkbox-component', className: 'checkbox-component-container', children: [_jsx("input", { "data-testid": testId, type: 'checkbox', ...props }), _jsx(Checkmark, {}), _jsx(Label, { label: label })] }));
};
